import React from 'react';
import type { ReactElement } from 'react';

import { useInitializeTheme } from './useInitializeTheme';

export const ThemeContainer = ({ children }: { children: ReactElement }) => {
	const isInitialized: boolean = useInitializeTheme();

	if (!isInitialized) {
		return <></>;
	}
	return <>{children}</>;
};
